import * as yup from 'yup';

const hexColorRegex = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/;

const tierLevelSchema = yup.object().shape({
  id: yup.string(),
  name: yup.string().required('Name is required').trim(),
  label: yup.string().required('Label is required').trim(),
  color: yup
    .string()
    .required('Color is required')
    .matches(hexColorRegex, 'Color must be a valid hex (#RGB or #RRGGBB)'),
  minOrders: yup
    .number()
    .integer('Must be a whole number')
    .min(0, 'Must be 0 or greater')
    .required('Min orders is required'),
  minSpent: yup
    .number()
    .min(0, 'Must be 0 or greater')
    .required('Min spend is required'),
  order: yup.number().integer().min(0).required(),
});

export const tierConfigSchema = yup.object().shape({
  defaultTier: yup.string().required('Default tier is required'),
  defaultTierColor: yup
    .string()
    .required('Default tier color is required')
    .matches(hexColorRegex, 'Default tier color must be a valid hex'),
  tiers: yup
    .array()
    .of(tierLevelSchema)
    .min(1, 'At least one tier is required')
    .test('unique-names', 'Tier names must be unique', (tiers) => {
      if (!tiers || tiers.length < 2) return true;
      const names = tiers.map((t) => (t.name || '').trim()).filter(Boolean);
      return new Set(names).size === names.length;
    })
    .test(
      'defaultTier-exists',
      'Default tier must be one of the tier names',
      function (tiers) {
        const defaultTier = this.parent.defaultTier;
        if (!defaultTier || !tiers?.length) return true;
        return tiers.some((t) => (t.name || '').trim() === defaultTier.trim());
      }
    ),
});

export { tierLevelSchema, hexColorRegex };
